<h1 class="sr-only">Add Comment Dialog</h1>
<h2  mat-dialog-title>Add Comment</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <section>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Comment</mat-label>
          <textarea matInput [(ngModel)]="comment" name="comment" rows="3" cols="100"></textarea>
        </mat-form-field>
      </div>
    </div>
  </section>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="cancel()" class="btn modal-btn-white">Cancel</button>
  <button  mat-button mat-dialog-close (click)="submit()" class="btn btn-primary modal-btn-blue" [disabled]="!comment">Save</button>
</mat-dialog-actions>